import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemplate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1507_54091)",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "path-1-inside-1_1507_54091",
				fill: "white",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 16,
					height: 16,
					rx: .462963
				})
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				rx: .462963,
				stroke: "currentColor",
				strokeOpacity: 1,
				strokeWidth: 2.5,
				mask: "url(#path-1-inside-1_1507_54091)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.32614 7.32009H12.617C12.7181 7.32009 12.8001 7.24216 12.8001 7.14596V4.01398C12.8001 3.91778 12.7181 3.83984 12.617 3.83984H9.32614C9.22502 3.83984 9.1431 3.91778 9.1431 4.01398V5.14524H7.40614C7.35622 5.14524 7.31526 5.18421 7.31526 5.2317V7.92896H6.2183V6.75385C6.2183 6.65765 6.13638 6.57972 6.03526 6.57972H2.7431C2.64198 6.57972 2.56006 6.65765 2.56006 6.75385V9.88583C2.56006 9.98203 2.64198 10.06 2.7431 10.06H6.03398C6.1351 10.06 6.21702 9.98203 6.21702 9.88583V8.71073H7.31398V11.408C7.31398 11.4555 7.35494 11.4944 7.40486 11.4944H9.14182V12.6257C9.14182 12.7219 9.22374 12.7998 9.32486 12.7998H12.6157C12.7169 12.7998 12.7988 12.7219 12.7988 12.6257V9.49616C12.7988 9.39996 12.7169 9.32203 12.6157 9.32203H9.32614C9.22502 9.32203 9.1431 9.39996 9.1431 9.49616V10.7139H8.13702V5.92824H9.1431V7.14596C9.1431 7.24216 9.22502 7.32009 9.32614 7.32009ZM10.0109 4.66668H11.9309V6.49448H10.0109V4.66668ZM5.34918 9.23435H3.42918V7.40777H5.34918V9.23435ZM10.0109 10.1489H11.9309V11.9767H10.0109V10.1489Z",
				fill: "currentColor",
				fillOpacity: 1
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1507_54091",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "currentColor"
		})
	}) })]
});
export default SvgTemplate;
